export default __webpack_public_path__ + "static/media/back.a9eb8db7.svg";